export default {
  apiKey: 'AIzaSyCNRFAMS8CJzI-jEW6gAQQKr_X1ZeTOjlk',
  authDomain: 'boxcastweb.firebaseapp.com',
  databaseURL: 'https://boxcastweb-chat.firebaseio.com',
  projectId: 'boxcastweb',
  storageBucket: 'boxcastweb.appspot.com',
  messagingSenderId: '533634850734',
};
